import { render, staticRenderFns } from "./tagAdd.vue?vue&type=template&id=64a33e83&scoped=true"
import script from "./tagAdd.vue?vue&type=script&lang=js"
export * from "./tagAdd.vue?vue&type=script&lang=js"
import style0 from "./tagAdd.vue?vue&type=style&index=0&id=64a33e83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a33e83",
  null
  
)

export default component.exports